import { TextArea } from "@faire/web/slate/Input/TextArea";
import { FieldInputProps, useField } from "formik";
import React, { ChangeEvent, ComponentProps, useCallback } from "react";

type IProps = Omit<
  ComponentProps<typeof TextArea>,
  "error" | keyof FieldInputProps<unknown>
> & { name: string; trackChange?: (name: string, value: string) => void };

export const FormikTextArea: React.FC<IProps> = ({
  ref,
  name,
  trackChange,
  ...props
}) => {
  const [{ onChange, onBlur, ...field }, meta, { setTouched }] = useField(name);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      if (!e.target.value) {
        setTouched(false);
      }
      onChange(e);
    },
    [onChange, setTouched]
  );

  const handleBlur = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      trackChange?.(name, e.target.value);
      onBlur(e);
    },
    [name, onBlur, trackChange]
  );

  return (
    <TextArea
      ref={ref}
      {...props}
      {...field}
      error={meta.touched && meta.error}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
